import type { ReactNode } from 'react';

import { applyTheme } from '../../lib/theme.ts';
import { Card } from '../ui/card.tsx';
import { ThemePicker } from '../ui/theme-picker.tsx';
import { OfflineBanner } from '../layout/offline-banner.tsx';

/** Centered card for the access screens (login, 2FA, invitations, password). */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh">
      <OfflineBanner />
      <div className="lg:grid lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        {/* Brand moment: white text only over the dark part of the gradient. */}
        <aside className="bg-brand px-6 py-5 lg:flex lg:min-h-dvh lg:flex-col lg:justify-between lg:p-12">
          <p className="text-sm font-semibold tracking-widest text-white/85 uppercase">
            ERP Inmobiliario
          </p>
          <div className="hidden max-w-sm lg:block">
            <p className="text-3xl leading-tight font-semibold">
              Tu inmobiliaria, ordenada y segura.
            </p>
            <p className="mt-3 text-white/85">
              Contactos, propiedades, negocios y comisiones de tu equipo en un solo lugar.
            </p>
          </div>
          <p className="hidden text-xs text-white/75 lg:block">Zen Digital</p>
        </aside>
        <main className="mx-auto flex w-full max-w-md flex-col justify-center gap-6 p-4 py-8 lg:min-h-dvh">
          <Card className="space-y-5">
            <div className="space-y-1">
              <h1 className="text-2xl font-semibold">{title}</h1>
              {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
            </div>
            {children}
          </Card>
          {/* Before signing in: this browser only (theme.js applies it before painting).
              Signing in brings the account's saved preference. */}
          <ThemePicker className="mx-auto w-full max-w-64" onChange={applyTheme} />
        </main>
      </div>
    </div>
  );
}
